export const Stepper = ({ steps, currentStep }) => {
  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

  const isRetailerMobile =
    typeof window !== "undefined" &&
    window.innerWidth < 640 &&
    ( authUser?.role === 5 || authUser?.role === 6 );

  return (
    <div
      className={`
        flex items-center w-full mb-6 transition-all duration-300
        ${
          isRetailerMobile
            ? "bg-white/10 backdrop-blur-xl border border-white/20 rounded-2xl p-3"
            : ""
        }
      `}
    >
      {steps.map((step, index) => {
        const isActive = step.id <= currentStep;
        const isCurrent = step.id === currentStep;

        return (
          <div key={step.id} className="flex items-center flex-1">
            {/* STEP CIRCLE */}
            <div
              className={`
                z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold shrink-0 transition-all duration-300
                ${
                  isRetailerMobile
                    ? isActive
                      ? "bg-white text-blue-700 shadow-lg ring-2 ring-white/40"
                      : "bg-white/20 text-white"
                    : isActive
                    ? "bg-blue-600 text-white"
                    : "bg-slate-200 text-slate-600"
                }
              `}
            >
              {step.id}
            </div>

            {/* STEP NAME (DESKTOP ONLY) */}
            <span
              className={`
                ml-2 text-xs font-medium whitespace-nowrap hidden sm:inline
                ${
                  isRetailerMobile
                    ? "text-white/90"
                    : "text-slate-700"
                }
              `}
            >
              {step.name}
            </span>

            {/* CONNECTOR LINE */}
            {index < steps.length - 1 && (
              <div
                className={`
                  flex-1 h-px mx-2 sm:mx-3 transition-all duration-300
                  ${
                    isRetailerMobile
                      ? isActive
                        ? "bg-white/70"
                        : "bg-white/30"
                      : "bg-slate-300"
                  }
                `}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};


// export const Stepper = ({ steps, currentStep }) => (
//   <div className="flex items-center w-full mb-6">
//     {steps.map((step, index) => (
//       <div key={step.id} className="flex items-center flex-1">
//         {/* STEP CIRCLE */}
//         <div
//           className={`z-10 w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold shrink-0
//             ${
//               step.id <= currentStep
//                 ? "bg-blue-600 text-white"
//                 : "bg-slate-200 text-slate-600"
//             }`}
//         >
//           {step.id}
//         </div>

//         {/* STEP NAME (DESKTOP ONLY) */}
//         <span className="ml-2 text-xs font-medium text-slate-700 hidden sm:inline whitespace-nowrap">
//           {step.name}
//         </span>

//         {/* CONNECTOR LINE */}
//         {index < steps.length - 1 && (
//           <div
//             className="
//               flex-1
//               h-px
//               bg-slate-300
//               mx-2
//               sm:mx-3
//             "
//           />
//         )}
//       </div>
//     ))}
//   </div>
// );




// export const Stepper = ({ steps, currentStep }) => (
//   <div className="flex items-center justify-between mb-6">
//     {steps.map((step, index) => (
//       <div key={step.id} className="flex-1 flex items-center">
//         <div
//           className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-semibold
//             ${
//               step.id <= currentStep
//                 ? "bg-blue-600 text-white"
//                 : "bg-slate-200 text-slate-600"
//             }`}
//         >
//           {step.id}
//         </div>
//         <span className="ml-2 text-xs font-medium text-slate-700">
//           {step.name}
//         </span>
//         {index < steps.length - 1 && (
//           <div className="flex-1 h-px bg-slate-200 mx-2" />
//         )}
//       </div>
//     ))}
//   </div>
// );